<template>
  <div>
    <!-- COMPONENTE QUE GERA O LOADING EFECT -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- FIM COMPONENTE QUE GERA O LOADING EFECT -->

    <!-- CONTAINER ONDE PRENCHEMOS OS DADOS COMO TPA, COMPROVATIVO VALOR DO SALDO -->
    <v-col md="12">
      <v-row>
        <v-col cols="4" sm="4" md="4">
          <div class="tpaCombox">
            <v-combobox
              v-model="tpaSelectedField"
              label="Selecione a forma pagamento"
              item-value="num_recibo"
              item-text="num_recibo"
              :items="tpas"
              return-object
              rounded
            ></v-combobox>
          </div>
        </v-col>
        <v-col cols="4" sm="4" md="4">
          <v-text-field
            v-model="numeroComprovativo"
            label="Número do comprovativo"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="4" sm="4" md="4">
          <v-text-field
            v-model="saldoDigitado"
            label="valor do saldo"
            required
          ></v-text-field>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="resetarPagina()"> Cancelar </v-btn>
        <v-btn color="green darken-1" text @click="gerarSaldo($event)"> Guardar </v-btn>
      </v-card-actions>
    </v-col>
    <!-- FIM CONTAINER ONDE PRENCHEMOS OS DADOS COMO TPA, COMPROVATIVO VALOR DO SALDO -->

    <!-- CARD QUE EXIBIRÁ O POPUP DE SUCESSO CASO O SALDO FOR GERADO -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogoDone" persistent max-width="600px">
          <v-container
            style="background-color: #006699; color: white"
          ></v-container>
          <v-card>
            <v-card-text>
              <div style="text-align: center">
                <img style="width: 100px" src="../../assets/done.png" />
                <span style="font-size: 20px; font-weight: bold; display: block"
                  >Saldo gerado com sucesso!</span
                >
                <span style="font-size: 13px; font-weight: bold; display: block"
                  >Foram adiconados
                  <span style="color: green">{{
                    utilitarios.IntegerToMoneyValueFatura(saldoDigitado)
                  }}</span>
                  no saldo do estudante</span
                >
                <span style="font-size: 12px; font-weight: bold; display: block"
                  >Saldo antigo:
                  <span style="color: red">{{
                    utilitarios.IntegerToMoneyValueFatura(saldoEstudanteOld)
                  }}</span></span
                >
                <span style="font-size: 12px; font-weight: bold; display: block"
                  >Saldo actual:
                  <span style="color: blue">{{
                    utilitarios.IntegerToMoneyValueFatura(saldoEstudante)
                  }}</span></span
                >
              </div>
              <div style="text-align: center">
                <v-btn
                  style="margin-right: 3px"
                  color="success"
                  @click="imprimirRecibo()"
                  >Imprimir Recibo <v-icon> print</v-icon>
                </v-btn>
                <v-btn
                  style="margin-left: 3px"
                  color="primary"
                  @click="resetarPagina()"
                  >Fechar</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- FIM CARD QUE EXIBIRÁ O POPUP DE SUCESSO CASO O SALDO FOR GERADO -->
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import Swal from "sweetalert2";
import utilitarios from "../../plugins/utilitarios";
const ls = require("local-storage");
export default {
  name: "GerarSaldo",
  props: ["estudante", "saldo"],
  data: () => ({
    overlay: false,
    saldoEstudante: 0,
    saldoEstudanteOld: 0,
    saldoDigitado: undefined,
    numeroComprovativo: undefined,
    utilitarios: utilitarios,
    dialogoDone: false,
    tpaSelectedField: null,
    tpas: [],
  }),

  computed: {
    usuario() {
      return ls.get("nomeUsuario");
    },
  },

  async created() {
    await this.initializeTPA();
  },

  methods: {
    async initializeTPA() {
      try {
        this.overlay = true;
        this.tpas = await axios.get("/tpasFindAll").then((res) => res.data);
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao carregar os dados dos TPAs",
          "error"
        );
      } finally {
        this.overlay = false;
      }
    },

    async gerarSaldo(event) {
      event.preventDefault();
      this.overlay = true;
      try {
        if (
          !isNaN(this.saldoDigitado) &&
          this.tpaSelectedField &&
          !isNaN(this.numeroComprovativo)
        ) {
          let params = {
            cliente: this.estudante.nome,
            nif: this.estudante.bi,
            idCliente: this.estudante.idCliente,
            matricula: this.estudante.numero_matricula,
            saldo: this.saldoDigitado,
            numeroComprovativo: this.numeroComprovativo,
            tpaRef: this.tpaSelectedField.num_recibo,
            tpaId: this.tpaSelectedField.id,
            user: this.usuario,
          };

          let result = await axios
            .post("/gerarSaldo", params)
            .then((res) => res.data);
          if (result.length && result[0].last_insert_id > 0) {
            this.saldoEstudanteOld = this.saldo;
            this.saldoEstudante =
              parseInt(this.saldoDigitado) + parseInt(this.saldo);
            this.dialogoDone = true;
          }
        } else {
          Swal.fire(
            "Informação",
            "Por favor, preecha os campos corretamente!",
            "info"
          );
        }
      } catch (error) {
        Swal.fire(
          "Erro",
          "Ocorreu um erro durante o registro do saldo!",
          "error"
        );
      } finally {
        this.overlay = false;
      }
    },

    resetarPagina() {
      this.dialogoDone = false;
      this.saldoDigitado = undefined;
      (this.saldoEstudante = 0),
        (this.saldoEstudanteOld = 0),
        (this.saldoDigitado = ""),
        (this.numeroComprovativo = ""),
        (this.tpaSelectedField = null),
        (this.tpas = []);
      this.$emit("fecharComponente", false);
    },

    imprimirRecibo() {
      this.$emit("imprimirComprovativo", true);
    },
  },
};
</script>

<style scoped>
.input-container {
  margin-top: 20px;
  padding: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
}
.input-container > div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.input-saldo {
  border: 1px solid #808080;
  padding: 10px;
  border-radius: 10px;
  display: block;
  width: 90%;
  margin-bottom: 10px;
  text-align: center;
  cursor: pointer;
}
input.input-saldo:focus {
  border-color: #808080;
}
.buttons_saldo_opcoes {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.input-button {
  display: block;
  background-color: #008000;
  padding: 10px;
  border-radius: 5px;
  color: #fff;
  font-weight: bold;
  transition: all 0.5s;
}
.input-button:hover {
  transition: all 0.5s;
  background-color: #0d530d;
}
.tpaCombox {
  height: 50px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 3px;
}
</style>
